<template>
  <div class="position-relative">
    <!-- Global loading overlay synced with child components -->
    <div v-if="isLoading" class="report-loading-overlay d-flex align-items-center justify-content-center">
      <div class="text-center">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
        <div class="mt-1">Loading report…</div>
      </div>
    </div>
    <b-tabs horizontal pills fill v-model="activeTab">
      <b-tab title="⚙️ Dashboard">
        <dashboard-graphs v-if="activeTab == 0" @loading="syncLoading"></dashboard-graphs>
      </b-tab>
      <b-tab title="📜 Task Report">
        <task-report v-if="activeTab == 1" @loading="syncLoading"></task-report>
      </b-tab>
      <b-tab title="👤 User Report">
        <user-report v-if="activeTab == 2" @loading="syncLoading"></user-report>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import DashboardGraphs from './DashboardGraphs.vue';
import TaskReport from './TaskReport.vue';
import UserReport from './UserReport.vue';

export default {
  components: {
    DashboardGraphs,
    TaskReport,
    UserReport,
  },

  mounted() {},

  data() {
    return {
      activeTab: 0,
      isLoading: false,
      loadingCount: 0,
    };
  },

  methods: {
    // Children emit @loading with true/false; we aggregate to control overlay
    syncLoading(state) {
      if (state === true) {
        this.loadingCount += 1;
      } else if (state === false && this.loadingCount > 0) {
        this.loadingCount -= 1;
      }
      this.isLoading = this.loadingCount > 0;
    },
  },
};
</script>

<style scoped>
.report-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255,255,255,0.85);
  z-index: 10;
}
</style>
